var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#177E9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_5287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.8333L13 10.5833H9.5C9.36739 10.5833 9.24021 10.5394 9.14645 10.4613C9.05268 10.3832 9 10.2772 9 10.1667V7.66667C9 7.55616 9.05268 7.45018 9.14645 7.37204C9.24021 7.2939 9.36739 7.25 9.5 7.25H14C14.1326 7.25 14.2598 7.2939 14.3536 7.37204C14.4473 7.45018 14.5 7.55616 14.5 7.66667V11.8333Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.2498V13.0832C11 13.1937 10.9473 13.2997 10.8536 13.3778C10.7598 13.4559 10.6326 13.4998 10.5 13.4998H7L5.5 14.7498V10.5832C5.5 10.4727 5.55268 10.3667 5.64645 10.2885C5.74021 10.2104 5.86739 10.1665 6 10.1665H7",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_5287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white",
    transform: "translate(4 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadSearch);
export default __webpack_public_path__ + "static/media/thread-search.7a9ebcb6dfdd59b102f2e012a9b66eaa.svg";
export { ForwardRef as ReactComponent };